/* eslint-disable */
import appRoutes from '../routes/exams/gmat-focus/app-routes';
import { isDevEnv } from '../utils/CommonUtils';
import AppRoutes from '../views/config/AppRoutes';
import { messages } from './messages';
export const defaultDateFormat = 'YYYY-MM-DD';
export const optionsArr = ['choice_a', 'choice_b', 'choice_c'];

/**
 * Feature flag — hide the CFA Unlimited+ package (#216, exam_plans.id = 78) from
 * the purchase flow and subscription-detail view until the launch. Flipping this
 * to `true` re-enables the Plus card on `/subscribe/selectPackage/cfa/1` and the
 * "CFA Unlimited+ Package" label on `/subscriptiondetail`.
 *
 * Backend entitlements (webinar access, ownership checks, WooCommerce webhook)
 * stay active regardless — this flag only controls the marketing surface.
 */
export const SHOW_CFA_UNLIMITED_PLUS = true;
export const CFA_UNLIMITED_PLUS_PACKAGE_ID = 78;
export const pad = (num) => {
  return `0${num}`.slice(-2);
};
export const SecondsToHHMMSS = (sec) => {
  const hours = Math.floor(sec / (60 * 60));

  const divisorForMinutes = sec % (60 * 60);
  const minutes = Math.floor(divisorForMinutes / 60);

  const divisorForSeconds = divisorForMinutes % 60;
  const seconds = Math.ceil(divisorForSeconds);
  return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
};
export const SecondsToMMSS = (sec) => {
  Math.floor(sec / (60 * 60));

  const divisorForMinutes = sec % (60 * 60);
  const minutes = Math.floor(divisorForMinutes / 60);

  const divisorForSeconds = divisorForMinutes % 60;
  const seconds = Math.ceil(divisorForSeconds);
  return `${pad(minutes)}:${pad(seconds)}`;
};
export const filterObj = ['Unattempted', 'Attempted', 'Flagged'];
export const frmOptionsArr = ['choice_a', 'choice_b', 'choice_c', 'choice_d'];
export const flowPlayerVideoLessonUrl = (url_id_qq) =>
  `https://cdn.flowplayer.com/b3390c02-b80b-44ff-acdb-befff01546ae/i/v-i-${url_id_qq}.jpg`;
// graph constants
export const flowPlayerVideoDisplayUrl = (url_id_qq) =>
  `//ljsp.lwcdn.com/api/video/embed.jsp?id=${url_id_qq}&pi=080de783-b4bf-4b42-ac09-e782c8a907ef`;
export const canvasjsConfig = {
  axisY: {
    includeZero: false,
    valueFormatString: ' ',
    stripLines: [
      {
        color: 'hsl(180deg 1% 83%)',
        startValue: 70,
        endValue: 70.5,
        label: '70%',
        labelFontColor: 'black',
        labelFontSize: 15,
        labelBackgroundColor: '#ffffff',
      },
      {
        color: 'hsl(180deg 1% 83%)',
        startValue: 50,
        endValue: 50.5,
        label: '50%',
        labelFontColor: 'black',
        labelFontSize: 15,
        labelBackgroundColor: '#ffffff',
      },
    ],
    gridThickness: 0,

    tickLength: 0,
    labelAutoFit: true,
    interval: 10,
    labelFontFamily: "'Roboto', sans-serif",
  },

  toolTip: { enabled: false },
  axisX: {
    gridThickness: 0,
    valueFormatString: ' ',
    labelFontSize: 15,
    labelFontColor: '#000000',
    labelAutoFit: true,
    labelMaxWidth: 175,
    labelWrap: true,
    dataPointWidth: 90,
    dataPointMaxWidth: 90,
    dataPointMinWidth: 90,
    labelAngle: 0,
    interval: 1,
    tickLength: 15,
    tickColor: '#fff',
    // dataPointWidth: 50,
    labelFontFamily: "'Roboto', sans-serif",
  },
};
export const lengthCheck = {
  ZERO: 0,
  HUNDRED: 100,
  ONE_HUNDRED_FIFTY: 150,
};
export const tabActionButtonStyles = {
  edit: 'fa fa-pencil-square-o mark-action-btn-dashboard',
  delete: 'fa fa-trash mark-action-btn-dashboard',
  viewFeedback: 'fa fa-exclamation-circle fa-rotate-180 mark-action-btn-dashboard',
  view: 'fa fa-eye mark-action-btn-dashboard',
  primaryColor: '#1f8ceb',
  deleteColor: '#f51a00',
};
// calculator constants
export const buttonCyphers = [1, 2, 3, 4, 5, 6, 7, 8, 9, 0];

export const operationCyphers = ['-', '+', '/', 'x', '.', '√', '%', '+/-'];
// eslint-disable-next-line
export const OperatorExpression = /\+|\*|\-|\/|\%/;
export const specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;

// Google tag Manager and GA4
export const GTM_ID = 'GTM-KF7B5DD';
export const GtmAddToCart = 'addToCart';
export const GA4AddToCart = 'add_to_cart';
export const Currency = 'USD';
export const GTMStartPayment = 'startPayment';
export const GA4BeginCheckout = 'begin_checkout';
export const GTMSignUp = 'signup';
export const GA4SignUp = 'sign_up';
export const GTMPurchaseCompleted = 'purchaseCompleted';
export const GA4Purchase = 'purchase';
export const GTMAddPaymentInfo = 'addPaymentInfo';
export const GA4AddPaymentInfo = 'add_payment_info';
export const GTMPaymentFailed = 'paymentFailed';
export const GA4PaymentFailed = 'payment_failed';
export const GTMUserInfo = 'userInfo';
export const DIVISOR_FOR_CASES = 6;

// Show the year-suffixed label only on localhost + the qfix dev env (where the
// 2027 preview is being staged). Production keeps the plain "CFA Level I" label.
// const CFA_LEVEL_I = isDevEnv ? 'CFA Level I - 2026' : 'CFA Level I';
const CFA_LEVEL_I = 'CFA Level I';
const CFA_LEVEL_II = 'CFA Level II';
const CFA_LEVEL_III = 'CFA Level III';
const CFA_LEVEL_I_2026 = 'CFA Level I - 2026';
const CFA_LEVEL_I_2027 = 'CFA Level I - 2027';
const CFA_LEVEL_II_2026 = 'CFA Level II - 2026';
const CFA_LEVEL_II_2027 = 'CFA Level II - 2027';
// const CFA_LEVEL_III_2026 = 'CFA Level III 2026';

  // the logic unifying and combining cfa exams;
  // cfa_2026 --> cfa_2025
  // cfa_2_2026 --> cfa_2_2025
  // cfa_3_2026 --> cfa_3_2025

export const examNames = {
  // 2027 is open to all users, so the 2026 edition must show the year suffix too — otherwise the
  // header/dropdown can't tell "CFA Level I - 2026" apart from "CFA Level I - 2027". All three 2026
  // CFA1 codes (bare cfa, cfa_2025 = the dropdown value for 2026, cfa_2026) get the "- 2026" label.
  cfa: CFA_LEVEL_I_2026,
  cfa_2025: CFA_LEVEL_I_2026,
  cfa_2026: CFA_LEVEL_I_2026,
  cfa_2027: CFA_LEVEL_I_2027,
  cfa_2: CFA_LEVEL_II,
  cfa_2_2025: CFA_LEVEL_II_2026,
  cfa_2_2026: CFA_LEVEL_II_2026,
  cfa_2_2027: CFA_LEVEL_II_2027,
  cfa_3: CFA_LEVEL_III,
  cfa_3_2025: CFA_LEVEL_III,
  // cfa_3_2026: CFA_LEVEL_III_2026,
  cfa_3_2026: CFA_LEVEL_III,
  frm: 'FRM Part I & II',
  soa_p: 'Actuarial - P (Probability)',
  soa_fm: 'Actuarial - FM (Financial Mathematics)',
  gmat: 'GMAT Focus',
  gmat_focus: 'GMAT Focus',
  ea: 'Executive Assessment',
  esg: 'ESG',
};

const { gmat } = examNames;

export const menuItems = {
  [gmat]: {
    localStorageKey: 'gmat',
    activeState: 'gmatActive',
    routePath: AppRoutes.GMAT_DASHBOARD,
    selectedMenuKey: 'selectedmenugmat',
  },
  'Executive Assessment': {
    localStorageKey: 'ea',
    activeState: 'EActive',
    routePath: AppRoutes.EA_DASHBOARD,
    selectedMenuKey: 'selectedmenuEA',
  },
  // 'CFA Level I 2023': {
  //   localStorageKey: 'cfa_2023',
  //   activeState: 'cfa1_2023_Active',
  //   routePath: AppRoutes.CFA1_2023_DASHBOARD,
  //   selectedMenuKey: 'selectedmenucfa2023',
  // },
  'CFA Level I': {
    localStorageKey: 'cfa_2024',
    activeState: 'cfa1_2024_Active',
    routePath: AppRoutes.CFA1_2025_DASHBOARD,
    selectedMenuKey: 'selectedmenucfa2024',
  },
  'CFA Level II 2025': {
    localStorageKey: 'cfa_2_2025',
    activeState: 'cfa22025Active',
    routePath: AppRoutes.CFA2_2025_DASHBOARD,
    selectedMenuKey: 'selectedmenucfa_2',
  },
  'CFA Level III': {
    localStorageKey: 'cfa_3',
    activeState: 'cfa3Active',
    routePath: AppRoutes.CFA3_DASHBOARD,
    selectedMenuKey: 'selectedmenucfa_3',
  },

  'FRM Part I & II': {
    localStorageKey: 'frm',
    activeState: 'frmActive',
    routePath: AppRoutes.FRM_DASHBOARD,
    selectedMenuKey: 'selectedmenufrm',
  },
  'Actuarial - P (Probability)': {
    localStorageKey: 'soa_p',
    activeState: 'soaPActive',
    routePath: AppRoutes.SOA_PROBABILITY_DASHBOARD,
    selectedMenuKey: 'selectedmenufrm',
  },
  'Actuarial - FM (Financial Mathematics)': {
    localStorageKey: 'soa_fm',
    activeState: 'soaFMActive',
    routePath: AppRoutes.SOA_FINANCIAL_MATHMATICS_DASHBOARD,
    selectedMenuKey: 'selectedmenufrm',
  },

  ESG: {
    localStorageKey: 'esg',
    activeState: 'esgActive',
    routePath: AppRoutes.ESG_DASHBOARD,
    selectedMenuKey: 'selectedmenuesg',
  },
};
export const ROLES = {
  EMPLOYEE: 'employee',
  USER: 'user',
  PARTNER: 'partner',
};
export const routeExamName = {
  // CFA_LEVEL_1: '/cfa_2023',
  CFA_LEVEL_1_2024: '/cfa_2024',
  CFA_LEVEL_2: '/cfa2_2023',
  CFA_LEVEL_3: '/cfa3',
  ESG: '/esg',
  FRM: '/frm',
  SOA_P: '/soa/probability',
  SOA_FM: '/soa/financialmathematics',
  GMAT: '/gmat',
  GMAT_FOCUS: '/gmat-focus',
  EA: '/ea',
};
// Baked in at image build time -- CRA inlines REACT_APP_* into the bundle, so
// this varies per environment through the --build-arg in .gitlab/ci/build.yml,
// not through the runtime lms-ui ConfigMap. Unlike the backend's
// AWS_S3_BUCKET_NAME this keeps a production default: the frontend only reads
// public objects, so a missed build arg showing production images is far less
// bad than every image on the page breaking.
const DEFAULT_S3_BASE_URL = 'https://s3.amazonaws.com/app.analystprep.com';
export const S3_BASE_URL =
  process.env.REACT_APP_S3_BASE_URL || DEFAULT_S3_BASE_URL;
export const ADMIN_PROFILE_BASE_URL = `${S3_BASE_URL}/profile/admin`;
export const ANALYSTPREP_LOGO = '/img/logo_small.png';
export const examNameAccordingToDB = {
  CFA: 'cfa',
  CFA_LEVEL_1_2024: 'cfa_2024',
  CFA_LEVEL_1_2025: 'cfa_2025',
  CFA_LEVEL_1_2026: 'cfa_2026',
  CFA_LEVEL_1_2027: 'cfa_2027',
  CFA_2: 'cfa_2',
  CFA_LEVEL_2: 'cfa_2_2023',
  CFA_LEVEL_2_2025: 'cfa_2_2025',
  CFA_LEVEL_2_2026: 'cfa_2_2026',
  CFA_LEVEL_2_2027: 'cfa_2_2027',
  CFA_LEVEL_3: 'cfa_3',
  CFA_LEVEL_3_2025: 'cfa_3_2025',
  CFA_LEVEL_3_2026: 'cfa_3_2026',
  ESG: 'esg',
  FRM: 'frm',
  SOA_P: 'soa_p',
  SOA_FM: 'soa_fm',
  GMAT: 'gmat_focus',
  GMAT_FOCUS: 'gmat_focus',
  EA: 'ea',
};

const {
  CFA_LEVEL_1_2024,
  CFA_LEVEL_1_2025,
  CFA_LEVEL_1_2026,
  CFA_LEVEL_1_2027,
  CFA_LEVEL_2,
  CFA_LEVEL_2_2025,
  CFA_LEVEL_2_2026,
  CFA_LEVEL_2_2027,
  CFA_LEVEL_3,
  CFA_LEVEL_3_2025,
  CFA_LEVEL_3_2026,
  ESG,
  FRM,
  SOA_P,
  SOA_FM,
  GMAT,
  GMAT_FOCUS,
  EA,
} = examNameAccordingToDB;

export const examObject = {
  [FRM]: {
    dbName: FRM,
    routeStartWith: routeExamName[FRM],
    fullName: examNames[FRM],
    sidebarRoutes: {
      dashboard: AppRoutes.FRM_DASHBOARD,
      notes: AppRoutes.FRM_NOTES,
      videos: AppRoutes.FRM_VIDEOS,
      questions: AppRoutes.FRM_QUESTION_BANK,
      quiz: AppRoutes.FRM_QUIZZES,
      cbt: AppRoutes.FRM_CBT,
      subscription: AppRoutes.SUBSCRIBE,
    },
  },

  [CFA_LEVEL_1_2025]: {
    dbName: CFA_LEVEL_1_2025,
    fullName: examNames[CFA_LEVEL_1_2025],
    routeStartWith: routeExamName[CFA_LEVEL_1_2025],
    sidebarRoutes: {
      dashboard: AppRoutes.CFA1_2025_DASHBOARD,
      notes: AppRoutes.CFA1_2025_NOTES,
      videos: AppRoutes.CFA1_VIDEOS,
      questions: AppRoutes.CFA1_2025_QUESTION_BANK,
      quiz: AppRoutes.CFA1_2025_QUIZZES,
      cbt: AppRoutes.CFA1_2024_CBT,
      tutor: AppRoutes.Tutor,
      subscription: AppRoutes.SUBSCRIBE,
    },
  },
  [CFA_LEVEL_1_2026]: {
    dbName: CFA_LEVEL_1_2026,
    fullName: examNames[CFA_LEVEL_1_2025],
    routeStartWith: routeExamName[CFA_LEVEL_1_2025],
    sidebarRoutes: {
      dashboard: AppRoutes.CFA1_2025_DASHBOARD,
      notes: AppRoutes.CFA1_2025_NOTES,
      videos: AppRoutes.CFA1_VIDEOS,
      questions: AppRoutes.CFA1_2025_QUESTION_BANK,
      quiz: AppRoutes.CFA1_2025_QUIZZES,
      cbt: AppRoutes.CFA1_2024_CBT,
      tutor: AppRoutes.Tutor,
      subscription: AppRoutes.SUBSCRIBE,
    },
  },
  [CFA_LEVEL_1_2027]: {
    dbName: CFA_LEVEL_1_2027,
    fullName: examNames[CFA_LEVEL_1_2027],
    routeStartWith: routeExamName[CFA_LEVEL_1_2025],
    // 2027 navigates its own year-free /cfa1/2027/... tree (unique + deep-linkable). Pointing the
    // sidebar/dropdown here keeps 2027 users inside /next/, and every /next/ URL forces cfa_2027 via
    // the #292 guard (common/examUrlResolver.js). 2025/2026 blocks above are untouched.
    sidebarRoutes: {
      dashboard: AppRoutes.CFA1_2027_NEXT_DASHBOARD,
      notes: AppRoutes.CFA1_2027_NEXT_NOTES,
      videos: AppRoutes.CFA1_2027_NEXT_VIDEOS,
      questions: AppRoutes.CFA1_2027_NEXT_QUESTION_BANK,
      quiz: AppRoutes.CFA1_2027_NEXT_QUIZZES,
      cbt: AppRoutes.CFA1_2027_NEXT_CBT,
      tutor: AppRoutes.Tutor,
      subscription: AppRoutes.SUBSCRIBE,
    },
  },
  [CFA_LEVEL_2_2025]: {
    dbName: CFA_LEVEL_2_2025,
    fullName: examNames[CFA_LEVEL_2_2025],
    routeStartWith: routeExamName[CFA_LEVEL_2_2025],
    sidebarRoutes: {
      dashboard: AppRoutes.CFA2_2025_DASHBOARD,
      notes: AppRoutes.CFA2_2025_NOTES,
      videos: AppRoutes.CFA2_2026_VIDEOS,
      questions: AppRoutes.CFA2_2025_QUESTION_BANK,
      quiz: AppRoutes.CFA2_2025_QUIZZES,
      cbt: AppRoutes.CFA2_CBT,
      tutor: AppRoutes.Tutor,
      subscription: AppRoutes.SUBSCRIBE,
    },
  },
  [CFA_LEVEL_2_2026]: {
    dbName: CFA_LEVEL_2_2026,
    fullName: examNames[CFA_LEVEL_2_2025],
    routeStartWith: routeExamName[CFA_LEVEL_2_2025],
    sidebarRoutes: {
      dashboard: AppRoutes.CFA2_2025_DASHBOARD,
      notes: AppRoutes.CFA2_2025_NOTES,
      videos: AppRoutes.CFA2_2026_VIDEOS,
      questions: AppRoutes.CFA2_2025_QUESTION_BANK,
      quiz: AppRoutes.CFA2_2025_QUIZZES,
      cbt: AppRoutes.CFA2_CBT,
      tutor: AppRoutes.Tutor,
      subscription: AppRoutes.SUBSCRIBE,
    },
  },
  // CFA2 2027 (employee-only preview). videos → CFA2_2027_VIDEOS ('/cfa2/2027/videos'): the SHARED
  // VideosComponent/VideosListing, but mounted under the /cfa2/2027 prefix and made prefix-aware (see
  // views/Videos/*), so every 2027 page stays under /cfa2/2027/*. It still calls the edition-neutral
  // /exams/cfa/videos/* endpoints, resolved to cfa2_2027_videos by token via examWiseTable under
  // examPreviewGuard — isolated — and avoids the broken standalone VideoLessons (chapters never load).
  [CFA_LEVEL_2_2027]: {
    dbName: CFA_LEVEL_2_2027,
    fullName: examNames[CFA_LEVEL_2_2027],
    routeStartWith: routeExamName[CFA_LEVEL_2_2025],
    sidebarRoutes: {
      dashboard: AppRoutes.CFA2_2027_DASHBOARD,
      notes: AppRoutes.CFA2_2027_NOTES,
      videos: AppRoutes.CFA2_2027_VIDEOS,
      questions: AppRoutes.CFA2_2027_QUESTION_BANK,
      quiz: AppRoutes.CFA2_2027_QUIZZES,
      cbt: AppRoutes.CFA2_2027_CBT,
      tutor: AppRoutes.Tutor,
      subscription: AppRoutes.SUBSCRIBE,
    },
  },
  [CFA_LEVEL_3]: {
    dbName: CFA_LEVEL_3,
    fullName: examNames[CFA_LEVEL_3],
    routeStartWith: routeExamName[CFA_LEVEL_3],
    sidebarRoutes: {
      dashboard: AppRoutes.CFA3_DASHBOARD_2025,
      notes: AppRoutes.CFA3_NOTES,
      videos: AppRoutes.CFA3_VIDEO_LESSONS,
      questions: AppRoutes.CFA3_QUESTION_BANK,
      quiz: AppRoutes.CFA3_QUIZZES,
      cbt: AppRoutes.CFA3_CBT,
      pathway: AppRoutes.CFA3_PATHWAY_CBT,
      tutor: AppRoutes.Tutor,
      subscription: AppRoutes.SUBSCRIBE,
      essay: AppRoutes.CFA3_ESSAY_QUESTION_CHAPTERS,
    },
  },
  [CFA_LEVEL_3_2025]: {
    dbName: CFA_LEVEL_3_2025,
    fullName: examNames[CFA_LEVEL_3_2025],
    routeStartWith: routeExamName[CFA_LEVEL_3_2025],
    sidebarRoutes: {
      dashboard: AppRoutes.CFA3_DASHBOARD_2025,
      notes: AppRoutes.CFA3_NOTES,
      videos: AppRoutes.VIDEOS,
      questions: AppRoutes.CFA3_QUESTION_BANK,
      quiz: AppRoutes.CFA3_QUIZZES,
      cbt: AppRoutes.CFA3_CBT,
      pathway: AppRoutes.CFA3_PATHWAY_CBT,
      tutor: AppRoutes.Tutor,
      subscription: AppRoutes.SUBSCRIBE,
      essay: AppRoutes.CFA3_ESSAY_QUESTION_CHAPTERS,
    },
  },
  [CFA_LEVEL_3_2026]: {
    dbName: CFA_LEVEL_3_2026,
    fullName: examNames[CFA_LEVEL_3_2025],
    routeStartWith: routeExamName[CFA_LEVEL_3_2025],
    sidebarRoutes: {
      dashboard: AppRoutes.CFA3_DASHBOARD_2025,
      notes: AppRoutes.CFA3_NOTES,
      videos: AppRoutes.VIDEOS,
      questions: AppRoutes.CFA3_QUESTION_BANK,
      quiz: AppRoutes.CFA3_QUIZZES,
      cbt: AppRoutes.CFA3_CBT,
      pathway: AppRoutes.CFA3_PATHWAY_CBT,
      tutor: AppRoutes.Tutor,
      subscription: AppRoutes.SUBSCRIBE,
      essay: AppRoutes.CFA3_ESSAY_QUESTION_CHAPTERS,
    },
  },
  [ESG]: {
    dbName: ESG,
    fullName: examNames[ESG],
    routeStartWith: routeExamName[ESG],
    sidebarRoutes: {
      dashboard: AppRoutes.ESG_DASHBOARD,
      notes: AppRoutes.ESG_NOTES,
      videos: AppRoutes.ESG_VIDEOS,
      questions: AppRoutes.ESG_QUESTION_BANK,
      quiz: AppRoutes.ESG_QUIZZES,
      cbt: AppRoutes.ESG_CBT,
      tutor: AppRoutes.Tutor,
      subscription: AppRoutes.SUBSCRIBE,
    },
  },
  [SOA_P]: {
    dbName: SOA_P,
    fullName: examNames[SOA_P],
    routeStartWith: routeExamName[SOA_P],
    sidebarRoutes: {
      dashboard: AppRoutes.SOA_PROBABILITY_DASHBOARD,
      notes: AppRoutes.SOA_PROBABILITY_NOTES,
      videos: AppRoutes.SOA_PROBABILITY_VIDEO_LESSONS,
      questions: AppRoutes.SOA_PROBABILITY_QUESTION_BANK,
      quiz: AppRoutes.SOA_PROBABILITY_QUIZZES,
      tutor: AppRoutes.Tutor,
      subscription: AppRoutes.SUBSCRIBE,
    },
  },
  [SOA_FM]: {
    dbName: SOA_FM,
    fullName: examNames[SOA_FM],
    routeStartWith: routeExamName[SOA_FM],
    sidebarRoutes: {
      dashboard: AppRoutes.SOA_FINANCIAL_MATHMATICS_DASHBOARD,
      notes: AppRoutes.SOA_FINANCIAL_MATHMATICS_NOTES,
      videos: AppRoutes.SOA_FINANCIAL_MATHMATICS_VIDEO_LESSONS,
      questions: AppRoutes.SOA_FINANCIAL_MATHMATICS_QUESTION_BANK,
      quiz: AppRoutes.SOA_FINANCIAL_MATHMATICS_QUIZZES,
      tutor: AppRoutes.Tutor,
      subscription: AppRoutes.SUBSCRIBE,
    },
  },
  [GMAT]: {
    dbName: GMAT,
    fullName: examNames[GMAT],
    routeStartWith: routeExamName[GMAT],
    sidebarRoutes: {
      dashboard: AppRoutes.GMAT_DASHBOARD,
      videos: AppRoutes.GMAT_VIDEO_LESSONS,
      questions: AppRoutes.GMAT_QUESTION_BANK,
      quiz: AppRoutes.GMAT_QUIZZES,
      tutor: AppRoutes.Tutor,
      subscription: AppRoutes.SUBSCRIBE,
    },
  },
  [GMAT_FOCUS]: {
    dbName: GMAT_FOCUS,
    fullName: examNames[GMAT_FOCUS],
    routeStartWith: routeExamName[GMAT_FOCUS],
    sidebarRoutes: {
      dashboard: appRoutes.DASHBOARD,
      videos: appRoutes.VIDEO_LESSONS,
      questions: appRoutes.QUESTION_BANK,
      quiz: appRoutes.QUIZZES,
      tutor: AppRoutes.Tutor,
      subscription: AppRoutes.SUBSCRIBE,
    },
  },
  [EA]: {
    dbName: EA,
    fullName: examNames[EA],
    routeStartWith: routeExamName[EA],
    sidebarRoutes: {
      dashboard: AppRoutes.EA_DASHBOARD,
      videos: AppRoutes.EA_VIDEO_LESSONS,
      questions: AppRoutes.EA_QUESTION_BANK,
      quiz: AppRoutes.EA_QUIZZES,
      tutor: AppRoutes.Tutor,
      subscription: AppRoutes.SUBSCRIBE,
    },
  },
};

export const localStorageKeys = {
  loginId: 'loginID',
  selectedMenu: 'selectedmenu',
  token: 'token',
  email: 'idname',
  role: 'role',
  organizationDomain: 'organizationDomain',
  exam: 'exam',
  questionMode: 'questionMode',
  userTokenAndEmail: 'localstorageval',
  previousPath: 'previousPath',
  previousParams: 'previousParams',
  selectedLanguage: 'selectedLanguage',
};

//* Header, SignUp Exam list is shown from here
export const CFAExamList = () => {
  const isEmployee = localStorage.getItem('role') === ROLES.EMPLOYEE;

  return [
    // CFA Level 1: employees see the year-suffixed "CFA Level I - 2026" label — to
    // distinguish the live 2026 content from the staff-only 2027 preview below.
    // Everyone else sees the plain "CFA Level I". Same underlying exam value either way.
    // start comment this logic - TO IMPLEMENT cfa 1 2026, 2027 exam flow
    // {
    //   value: CFA_LEVEL_1_2025,
    //   label: isEmployee ? CFA_LEVEL_I_2026 : CFA_LEVEL_I,
    // },
    // // Staff-only 2027 preview.
    // ...(isEmployee
    //   ? [{ value: CFA_LEVEL_1_2027, label: CFA_LEVEL_I_2027 }]
    //   : []),
    // end

    // start uncomment - TO IMPLEMENT cfa 1 2026, 2027 exam flow
    { value: CFA_LEVEL_1_2025, label: CFA_LEVEL_I_2026 },
    { value: CFA_LEVEL_1_2027, label: CFA_LEVEL_I_2027 },
    // end
    
    { value: CFA_LEVEL_2_2025, label: examNames[CFA_LEVEL_2_2025] },
    // start comment this logic - TO IMPLEMENT cfa 2 2027 exam flow
    // Staff-only 2027 preview (while the content team works on the 2027 content).
    ...(isEmployee ? [{ value: CFA_LEVEL_2_2027, label: examNames[CFA_LEVEL_2_2027] }] : []),
    // end

    // start uncomment - TO IMPLEMENT cfa 2 2027 exam flow
    // { value: CFA_LEVEL_2_2027, label: examNames[CFA_LEVEL_2_2027] },
    // end
    { value: CFA_LEVEL_3_2025, label: examNames[CFA_LEVEL_3_2025] },
    { value: ESG, label: examNames[ESG] },
  ];
};

export const FRMExamList = [{ value: FRM, label: examNames[FRM] }];

export const ActuarialExamList = [
  { value: SOA_P, label: examNames[SOA_P] },
  { value: SOA_FM, label: examNames[SOA_FM] },
];

export const GMATExamList = [
  { value: GMAT_FOCUS, label: examNames[GMAT_FOCUS] },
  { value: EA, label: examNames[EA] },
];

export const getTokenWithEmail = () => {
  const storage_session = JSON.parse(localStorage.getItem('localstorageval'));
  return {
    token: storage_session['token'],
    idname: storage_session['idname'],
  };
};

// aliasName = {esg_chapters : ''}
const flattenObject = (obj, aliasName = {}, parentKey = '') => {
  const result = {};

  for (const key in obj) {
    const newKey = parentKey ? `${parentKey}.${key}` : key;

    if (typeof obj[key] === 'object' && !Array.isArray(obj[key])) {
      Object.assign(result, flattenObject(obj[key], aliasName, aliasName[key] || ''));
    } else {
      result[newKey] = obj[key];
    }
  }

  return result;
};

export const mergeTwoSortedArrayDataById = (
  array1,
  array2,
  key,
  operations = {
    flatObjectOnArray1: false,
    aliasName: {},
    flatObjectOnArray2: false,
  },
) => {
  const mergedArray = [];
  let iterator1 = 0;
  let iterator2 = 0;

  while (iterator1 < array1.length && iterator2 < array2.length) {
    if (array1[iterator1][key] < array2[iterator2][key]) {
      if (operations.flatObjectOnArray1)
        array1[iterator1] = flattenObject(array1[iterator1], operations.aliasName);
      mergedArray.push(array1[iterator1]);
      iterator1++;
    } else if (array1[iterator1][key] > array2[iterator2][key]) {
      if (operations.flatObjectOnArray2)
        array2[iterator2] = flattenObject(array2[iterator2], operations.aliasName);
      mergedArray.push(array2[iterator2]);
      iterator2++;
    } else {
      // IDs are equal, merge the objects
      if (operations.flatObjectOnArray1)
        array1[iterator1] = flattenObject(array1[iterator1], operations.aliasName);
      if (operations.flatObjectOnArray2)
        array2[iterator2] = flattenObject(array2[iterator2], operations.aliasName);

      mergedArray.push({ ...array1[iterator1], ...array2[iterator2] });
      iterator1++;
      iterator2++;
    }
  }

  // Append any remaining elements from array1 and array2
  while (iterator1 < array1.length) {
    if (operations.flatObjectOnArray1)
      array1[iterator1] = flattenObject(array1[iterator1], operations.aliasName);
    mergedArray.push(array1[iterator1]);
    iterator1++;
  }

  while (iterator2 < array2.length) {
    if (operations.flatObjectOnArray2)
      array2[iterator2] = flattenObject(array2[iterator2], operations.aliasName);
    mergedArray.push(array2[iterator2]);
    iterator2++;
  }

  return mergedArray;
};

export const SUBSCRIPTION_TYPES = {
  EXPENSIVE: 'expensive',
  UNLIMITED: 'unlimited',
  SIMPLE: 'simple',
};

export const Y_AXIS_SCALES = {
  scales: {
    yAxes: [
      {
        ticks: {
          min: 0,
          max: 100,
        },
      },
    ],
  },
};

export const SECTION_NAMES = {
  NOTES: ['notes'],
  VIDEOS: ['video', 'cfa3_video_display', 'videodisplay', 'videos', 'eavideodisplay'],
  QUESTION_BANK: [
    'question',
    'questions',
    'readings',
    'ea_readings',
    'ea_viewquestions',
    'beginchapter',
    'cases',
    'chapter',
    'viewquestions',
    'EATab',
    'EA2Statement',
    'EAMultipleStatement',
    'EATable',
    'ea_beginchapter',
    'gmat-tab',
    'gmat-two-part',
    'gmat-multi-statement',
    'gmat-table',
  ],
  QUIZZES: [
    'quiz',
    'beforestart',
    'beginquiz',
    'ea_beginquiz',
    'before-start',
    'ea_beforestart',
    'ea_beginquiz_tab',
    'ea_beginquiz_graph',
    'ea_beginquiz_table',
    'ea_beginquiz_twopart',
    'ea_beginquiz_case',
  ],
  DASHBOARD: ['dashboard', 'viewallquestions'],
  ESSAY_QUESTION: ['essay-question'],
  CBT: ['cbt', 'viewattemptedmock', 'introduction'],
  TUTOR: ['tutor'],
  SUBSCRIBE: ['subscribe'],
  PATHWAY: ['pathway'],
  WEBINARS: ['webinars'],
};

export const REDIRECTION_ROUTES = {
  cfa_2025: {
    notes: {
      pathname: AppRoutes.CFA1_2025_NOTES_READING_LIST,
      keys: [{ key: 'chapterId', apiKey: 'chapter_id' }],
    },
    question: {
      pathname: AppRoutes.CFA1_2025_QUESTION_BANK_READING_LIST,
      keys: [{ key: 'chapterId', apiKey: 'chapter_id' }],
    },
  },
  cfa_2_2025: {
    notes: {
      pathname: AppRoutes.CFA2_2025_NOTES_READINGS,
      keys: [{ key: 'chapter', apiKey: 'chapter_id_2025' }],
    },
    question: {
      pathname: AppRoutes.CFA2_2025_QUESTION_BANK_CASES,
      keys: [
        { key: 'id', apiKey: 'chapter_id_2025' },
        { key: 'chapter_name', apiKey: 'chapter_name' },
      ],
    },
  },
  cfa_3_2025: {
    notes: {
      pathname: AppRoutes.CFA3_NOTES_READINGS,
      keys: [{ key: 'chapter', apiKey: 'chapter_id' }],
    },
    question: {
      pathname: AppRoutes.CFA3_2025_QUESTION_BANK_READING_LIST,
      keys: [
        { key: 'id', apiKey: 'chapter_id' },
        { key: 'chapter_name', apiKey: 'chapter_name' },
      ],
    },
  },
};

const EXAM_CATEGORIES = {
  CFA_LEVEL_1: {
    examNames: ['cfa', 'cfa_2022', 'cfa_2023', 'cfa_2024', 'cfa_2025', 'cfa_2026', 'cfa_2027'],
    activeExam: 'cfa_2025',
  },
  CFA_LEVEL_2: {
    examNames: [
      'cfa_2',
      'cfa2',
      'cfa_2_2022',
      'cfa_2_2023',
      'cfa_2_2024',
      'cfa_2_2025',
      'cfa_2_2025',
      'cfa_2_2026',
      'cfa_2_2027',
    ],
    activeExam: 'cfa_2_2025',
  },
  CFA_LEVEL_3: {
    examNames: [
      'cfa_3',
      'cfa3',
      'cfa_3_2023',
      'cfa_3_2024',
      'cfa_3_2025',
      'cfa_3_2025',
      'cfa_3_2026',
    ],
    activeExam: 'cfa_3_2025',
  },
  ESG: { examNames: ['esg'], activeExam: 'esg' },
  FRM_PART_1: { examNames: ['frm1', 'frm'], activeExam: 'frm' },
  FRM_PART_2: { examNames: ['frm2', 'frm_2'], activeExam: 'frm_2' },
  FRM_COMBINED: { examNames: ['frm_1_2'], activeExam: 'frm' },
  SOA_P: { examNames: ['soa_p'], activeExam: 'soa_p' },
  SOA_FM: { examNames: ['soa_fm'], activeExam: 'soa_fm' },
  SOA_P_FM: { examNames: ['soa_p_fm_ifm'], activeExam: 'soa_p' },
  GMAT: { examNames: ['gmat', 'gmat_focus'], activeExam: 'gmat_focus' },
  EXECUTIVE_ASSESSMENT: { examNames: ['ea', 'EA'], activeExam: 'ea' },
};

export const getActiveExams = (examName) => {
  const exam = Object.values(EXAM_CATEGORIES).find(({ examNames }) => examNames.includes(examName));
  return exam ? exam.activeExam : null;
};

export const EXAM_PACKAGE_IDS = {
  GMAT_FOCUS: {
    PRACTICE: 57,
  },
};

export const CAPSULE_VIDEO_ID = 11;

export const CHOICE_MAPPING = {
  choice_a: 'A',
  choice_b: 'B',
  choice_c: 'C',
  choice_d: 'D',
  choice_e: 'E',
};

export const CHOICE_KEYS = ['choice_a', 'choice_b', 'choice_c'];

export const SUBSCRIPTION_STATUS = {
  FREE: 'free',
  PAID: 'paid',
};

export const QUESTION_TYPE = {
  CASE_QUESTION: 'case_question',
  QUESTION: 'question',
  TABLE_QUESTION: 'table_question',
  TWO_PART_QUESTION: 'two_part_question',
  GRAPH_QUESTION: 'graph_question',
  TAB_QUESTION: 'tab_question',
};

export const TABLE_NAME = {
  EA_QUESTION_STATS: 'ea_question_stat',
};

export const QUESTION_MODE = {
  PRACTICE: 'practice_mode',
  REVISION: 'revision_mode',
};

// Define and export exam name constants and a single EXAM_NAMES object
export const EXAM_NAMES = {
  CFA_1: 'cfa_1',
  CFA_2: 'cfa_2',
  CFA_3: 'cfa_3',
  ESG: 'esg',
  FRM: 'frm',
  SOA_P: 'soa_p',
  SOA_FM: 'soa_fm',
  GMAT_FOCUS: 'gmat_focus',
  EA: 'ea',
};

export const QUESTION_MODE_OPTIONS = [
  {
    id: QUESTION_MODE.PRACTICE,
    value: QUESTION_MODE.PRACTICE,
    label: messages.PRACTICE_MODE,
    description: messages.PRACTICE_MODE_DESC,
  },
  {
    id: QUESTION_MODE.REVISION,
    value: QUESTION_MODE.REVISION,
    label: messages.REVISION_MODE,
    description: messages.REVISION_MODE_DESC,
  },
];
export const EXAM_MAPPING = {
  cfa: 'CFA Level I',
  cfa_2: 'CFA Level II',
  cfa_3: 'CFA Level III',
  frm: 'FRM Part I',
  frm_2: 'FRM Part II',
  frm_1_2: 'FRM Part I & Part II',
  soa_p: 'Actuarial - P (Probability)',
  soa_fm: 'Actuarial - FM (Financial Mathematics)',
  soa_p_fm_ifm: 'Actuarial - P, FM & IFM',
  gmat: 'GMAT',
  ea: 'Executive Assessment',
  esg: 'ESG',
  gmat_focus: 'GMAT Focus',
};
export const FRM_LEVELS = {
  ONE: '1',
  TWO: '2',
};
export const EXAMS_WITH_IDS = [
  {
    id: 1,
    name: 'CFA Level I',
  },
  {
    id: 2,
    name: 'FRM Part I',
  },
  {
    id: 3,
    name: 'FRM Part II',
  },
  {
    id: 4,
    name: 'FRM Part I & Part II',
  },
  {
    id: 5,
    name: 'CFA Level II',
  },
  {
    id: 6,
    name: 'CFA Level III',
  },
  {
    id: 7,
    name: 'Actuarial - P (Probability)',
  },
  {
    id: 8,
    name: 'Actuarial - FM (Financial Mathematics)',
  },
  {
    id: 9,
    name: 'Actuarial - IFM (Investment and Financial Markets)',
  },
  {
    id: 10,
    name: 'Actuarial - P, FM & IFM',
  },
  {
    id: 11,
    name: 'Actuarial - IFM (Investment and Financial Markets)',
  },
  {
    id: 12,
    name: 'Actuarial - P, FM & IFM',
  },
  {
    id: 13,
    name: 'GMAT',
  },
  {
    id: 14,
    name: 'EA',
  },
  {
    id: 17,
    name: 'ESG',
  },
  {
    id: 19,
    name: 'GMAT Focus',
  },
];



// WEBPACK FOOTER //
// ./src/common/constant.js